class heartData {
	constructor(){
		this.value=''
		this.time=0
		this.lastY=0
		this.averageValue=0
		this.valueSaveArray=[]
		this.totalAverageValue=0
		this.valueList=[]
		this.totalValueSaveArray=[]
		this.averageHeartArray=[]
	}
	heartChange(value){
		this.time++;
		this.value=value
		this.valueList.push(value)
		const data=[]
		const i = value
		let y=0
		if(i<=60){
			y=60
		}else if(i<210){
			y=+i
		}else{
			y=210
		}
		this.getAverageValueFuc(y)
		if(Math.abs(this.averageValue-y)<=45&&Math.abs(this.lastY-y)<=60&&y!==60&y!==210){
			data.push({value:y,draw:true}) 
		}else{
			data.push({value:y,draw:false}) 
		}
		this.lastY=y
		return data[0]
	}
	getAverageValueFuc(yValue){
		let value=yValue;
		if(value>30&&value<210){
			//获取数组最后一位 值
			if(this.averageHeartArray.length===0){
				this.averageHeartArray.push(value)
				return ;
			}
			let lastValue=this.averageHeartArray[this.averageHeartArray.length-1];
			//如果最后一位 与当前值相差45bpm  则数组清空 从新开始计算
			if(Math.abs(value-lastValue)>45){
				this.averageHeartArray=[]
			}
			this.averageHeartArray.push(value)
			//当采集数据满3s的时候 导入计算
			if(this.averageHeartArray.length===12){
				this.averageValue=Math.floor(this.averageHeartArray.reduce((sum,i)=>sum+=i,0)/this.averageHeartArray.length) 
				this.totalAverageValue = this.averageValue
				if(this.valueSaveArray.length==0){
					//将平均值放入数组
					this.valueSaveArray.push(this.averageValue)
				}else{
					//获取数组最后一位 值
					let lastValue2=this.valueSaveArray[this.valueSaveArray.length-1];
					//如果最后一位 与当前值相差45bpm  则丢掉 从新开始计算
					if(Math.abs(lastValue2-this.averageValue)<=45){
						this.valueSaveArray.push(this.averageValue)
						this.averageValue=Math.floor(this.valueSaveArray.reduce((sum,i)=>sum+=i,0)/this.valueSaveArray.length)
					}
				}
				this.totalValueSaveArray.push(this.totalAverageValue)
				if(this.totalValueSaveArray.length>1){
					//将平均值放入数组
					this.totalAverageValue=Math.floor(this.totalValueSaveArray.reduce((sum,i)=>sum+=i,0)/this.totalValueSaveArray.length)
				}
				this.averageHeartArray=[]
			}
		}else{
			this.averageHeartArray=[]
		}
	}
}

export default heartData